'use strict';

define(
    'UserProfile',[
        'UserProfileSvc',
        'QuickDepositCtrl',
        'UserBalanceSvc'
    ],

    function (UserProfileSvc,
              QuickDepositCtrl,
              UserBalanceSvc) {

        angular.module('TVG.UserProfile', ['TVG.Security'])

            .service('UserProfileSvc', UserProfileSvc)

            .service('UserBalanceSvc', UserBalanceSvc)

            .controller('QuickDepositCtrl', QuickDepositCtrl)

            .filter('trust', function ($sce) {
                return $sce.trustAsHtml;
            })

            .filter('startFrom', function () {
                return function (input, start) {
                    start = +start;
                    return input.slice(start);
                };
            });
    }
);

